export const ANONYMIZED_EMAIL = 'anonymised@screenloop.com';
